import { MerchantOutletContext } from '@/@type/router/booking';
import BookingSeoHead from '@/components/public/booking/BookingSeoHead';
import BookingTermsAndConditions from '@/components/public/booking/terms/terms';
import { Container } from '@mui/material';
import { useOutletContext } from 'react-router-dom';

const OrderBuddyBookingTermsAndConditions = (): JSX.Element => {
    const { merchant } = useOutletContext<MerchantOutletContext>();

    return (
        <>
            <BookingSeoHead
                merchant={merchant}
                pageTitleSuffix="Booking Terms"
                pageDescriptionSuffix="Read the booking terms and conditions."
                shouldIndex={false}
            />
            <Container
                sx={{
                    width: { xs: '100vw', sm: '70vw' },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <BookingTermsAndConditions />
            </Container>
        </>
    );
};
export default OrderBuddyBookingTermsAndConditions;
